export enum Themes {
  DARK = 'dark',
  LIGHT = 'light',
}